import React, { memo } from 'react'
import { HeaderProps } from './types'
import Icon from '@/components/base/icon'
import Anchor from '@/components/base/anchor'
import clsx from 'clsx'
import useDirectionRtl from '@/hooks/useDirectionRtl'

const WhatsonCTAButton: React.FC<Pick<HeaderProps, 'whatsonCtaButton'>> = ({
  whatsonCtaButton,
}) => {
  const { isRtl } = useDirectionRtl()
  if (!whatsonCtaButton?.href || !whatsonCtaButton?.children) return null

  return (
    <Anchor
      type="button"
      {...whatsonCtaButton}
      className={clsx('whatson-cta-button', {
        'whatson-cta-rtl': isRtl,
      })}
    >
      <Icon name="whatson" />
      <span className="cta-marquee-text">{whatsonCtaButton?.children}</span>
    </Anchor>
  )
}

export default memo(WhatsonCTAButton)
